import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUSES = ["New", "Contacted", "Demo Scheduled", "Demo Completed", "Proposal Sent", "Converted", "Closed"];

export default function AdminDemos() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/demo-requests").then((r) => setItems(r.data.items));
    useEffect(() => { load(); }, []);

    const update = async (id, status) => {
        try {
            await api.patch(`/admin/demo-requests/${id}`, { status });
            toast.success(`Demo → ${status}`);
            load();
        } catch { toast.error("Update failed"); }
    };

    return (
        <div data-testid="admin-demos-page">
            <div className="eyebrow eyebrow--slate">Demo Requests</div>
            <h1 className="font-serif text-4xl text-navy mt-3">Scheduled Demos</h1>
            <div className="mt-8 grid gap-4">
                {items.map((d) => (
                    <div key={d.demo_id} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`demo-card-${d.reference}`}>
                        <div className="flex items-start justify-between gap-4 flex-wrap">
                            <div>
                                <div className="font-mono text-xs text-slate-400">{d.reference}</div>
                                <div className="font-serif text-lg text-navy mt-1">{d.first_name} {d.last_name} · {d.organization}</div>
                                <div className="text-slate-500 text-sm mt-1">{d.email} · {d.phone || "—"}</div>
                                <div className="mt-3 flex flex-wrap gap-4 text-xs">
                                    <span className="text-slate-400">Product: <span className="text-navy">{d.product}</span></span>
                                    <span className="text-slate-400">Size: <span className="text-navy">{d.org_size || "—"}</span></span>
                                    <span className="text-slate-400">Preferred: <span className="text-navy">{d.preferred_date || "—"} {d.preferred_time || ""}</span></span>
                                </div>
                                {d.message && <div className="mt-3 text-sm text-slate-600 border-l-2 border-[#E8B923] pl-3">{d.message}</div>}
                            </div>
                            <select value={d.status} onChange={(e) => update(d.demo_id, e.target.value)} className="border border-slate-200 rounded px-3 py-2 text-sm bg-white" data-testid={`demo-status-${d.reference}`}>
                                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                            </select>
                        </div>
                    </div>
                ))}
                {!items.length && <div className="text-center py-12 text-slate-400">No demo requests yet</div>}
            </div>
        </div>
    );
}
